const elementMap: { [key: string]: string } = {
  // Structural elements
  div: "Div",
  section: "Section",
  article: "Article",
  aside: "Aside",
  header: "Header",
  footer: "Footer",
  nav: "Navigation",
  main: "Main",

  // Text elements
  p: "Paragraph",
  span: "Span",
  h1: "Heading 1",
  h2: "Heading 2",
  h3: "Heading 3",
  h4: "Heading 4",
  h5: "Heading 5",
  h6: "Heading 6",

  // List elements
  ul: "Unordered List",
  ol: "Ordered List",
  li: "List Item",

  // Table elements
  table: "Table",
  tr: "Table Row",
  td: "Table Cell",
  th: "Table Header",

  // Form elements
  form: "Form",
  input: "Input",
  button: "Button",
  textarea: "Text Area",
  select: "Select",
  option: "Option",
  label: "Label",

  // Media elements
  img: "Image",
  video: "Video",
  audio: "Audio",

  // Other common elements
  a: "Link",
  br: "Line Break",
  hr: "Horizontal Rule",
  iframe: "Inline Frame",
};

export function getFullElementName(element: string = "Unknown") {
  return elementMap[element.toLowerCase()] || element;
}
